<template>
    <table class="table w-full font-mono" style="font-size: .75rem">
        <thead class="">
        <tr>
            <th class="text-left">MWST-Code</th>
            <th class="text-right">MWST-Satz</th>
            <th class="text-right">Bruttoumsatz</th>
            <th class="text-right">MWST-Betrag</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="text-left">U77</td>
            <td class="text-right">7.7%</td>
            <td class="text-right">111.55 CHF</td>
            <td class="text-right">7.98</td>
        </tr>
        <tr>
            <td class="text-left">U25</td>
            <td class="text-right">2.5%</td>
            <td class="text-right">0.00 CHF</td>
            <td class="text-right">0.00</td>
        </tr>
        <tr>
            <td class="text-left">U0</td>
            <td class="text-right">0.0%</td>
            <td class="text-right">0.00 CHF</td>
            <td class="text-right">0.00</td>
        </tr>
        </tbody>
    </table>

</template>

<script>

export default {}
</script>

<style scoped>

</style>
